const state = {
  user: JSON.parse(localStorage.getItem('user'))
}

const mutations = {
  onChangeCurrentUser (state, user) {
    state.user = user
    localStorage.setItem('user', JSON.stringify(user))
  }
}

const actions = {
  setCurrentUser ({commit}, user) {
    let newUser = !user ? null : {
      id: user.user_id,
      name: user.user_name,
      accessToken: user.token
    }
    commit('onChangeCurrentUser', newUser)
  }
}

const getters = {
  currentUser: state => state.user
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js